import { select, Store } from "@ngrx/store";
import { TabItem } from "../../models";
import * as coreSelectors from '../../../core/selectors/user.selectors';
import * as coreModels from '../../../core/models';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import * as _ from 'lodash';

export class PageWithTabsComponent {
  private viewPermissions$: Observable<coreModels.IPermissions>;
  public tabList: Array<TabItem> = [];

  getPermittedTabsObservable(): Observable<Array<TabItem>> {
    return this.viewPermissions$.pipe(map(permissions =>
      this.tabList.length ? this.tabList.filter(tab => tab.permission ? _.get(permissions, tab.permission, false) : true) : []
    ));
  }

  constructor(public store$: Store<any>) {
    this.viewPermissions$ = this.store$.pipe(select(coreSelectors.getUserUserViewPermissions));
  }
}
